import { FC } from 'react';

import { useEditStore } from 'page/CustomerPage/hooks';
import { DeleteModalView } from 'page/CustomerPage/components/EditModal/DeleteModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickDelete: () => void;
};

export const DeleteModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickDelete,
}) => {
  const { name, isOpenDeleteModal } = useEditStore();

  return (
    <>
      {/* 削除モーダル */}
      <DeleteModalView
        isOpen={isOpenDeleteModal}
        name={name}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickDelete={handleClickDelete}
      />
    </>
  );
};
